<template>
  <div class="compact-logo">
    <img class="compact-logo__image" alt="Logo" src="@/assets/logo.svg" />
  </div>
</template>

<style lang="scss" scoped>
.compact-logo {
  width: 64px;
  height: 64px;
  overflow: hidden;
  border-radius: 16px;
}
</style>
